var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.componentStatus)?_c('ckeditor',{class:{className: true},attrs:{"id":_vm.id,"name":_vm.name,"types":"full","config":_vm.ckconfig},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30372454","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/helpers/ckeditor/editor.vue
// module id = null
// module chunks = 